module.exports = __webpack_public_path__ + "img/throwing.4831ed7b.png";